import { useEffect } from 'react';

export function useSelectedLinkReset(
    selectedLinkedServiceId: string,
    options: { value: string }[],
    onUnavailable: () => void
): void {
    useEffect(() => {
        // The offered options are the authority: "eachservice" is still offered at zero
        // services, so it stays a validation error rather than a silent reset.
        if (options.some((option) => option.value === selectedLinkedServiceId)) {
            return;
        }
        onUnavailable();
    }, [selectedLinkedServiceId, options, onUnavailable]);
}
